import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Forms from './components/Forms';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import { useParams } from 'react-router-dom';

const VagasProcessoEncerradosCadastro = ({
  isReadOnly = false,
  id: propId,
  hideHeader = false
}) => {
  const { id: paramId } = useParams();
  const id = propId || paramId;
  const isEditing = !!id && !isReadOnly;
  const isViewing = isReadOnly;
  return <Container fluid>
      {!hideHeader && <Row>
          <Col md={12}>
            <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Processos encerrados',
          route: '/pages/vagas/processosencerrados'
        }, {
          name: isViewing ? 'Detalhes da Vaga (Encerrada)' : isEditing ? 'Editar Vaga' : 'Nova vaga'
        }]} />
          </Col>
        </Row>
      }
      
      <Row>
        <Col md={12}>
          <Forms isReadOnly={isReadOnly} />
        </Col>
      </Row>
    </Container>;
};

export default VagasProcessoEncerradosCadastro;
